import React from 'react';

export const RecordFlow = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.81 2H16.191C19.28 2 21 3.78 21 6.83V17.16C21 20.26 19.28 22 16.191 22H7.81C4.77 22 3 20.26 3 17.16V6.83C3 3.78 4.77 2 7.81 2ZM10.15 8.85C10.15 7.63 9.16 6.64 7.94 6.64C6.72 6.64 5.73 7.63 5.73 8.85C5.73 10.07 6.72 11.06 7.94 11.06C9.16 11.06 10.15 10.07 10.15 8.85ZM7.94 8.14C8.33 8.14 8.65 8.46 8.65 8.85C8.65 9.24 8.33 9.56 7.94 9.56C7.55 9.56 7.23 9.24 7.23 8.85C7.23 8.46 7.55 8.14 7.94 8.14ZM18.27 15.15C18.27 13.93 17.28 12.94 16.06 12.94C14.84 12.94 13.85 13.93 13.85 15.15C13.85 16.37 14.84 17.36 16.06 17.36C17.28 17.36 18.27 16.37 18.27 15.15ZM16.06 14.44C16.45 14.44 16.77 14.76 16.77 15.15C16.77 15.54 16.45 15.86 16.06 15.86C15.67 15.86 15.35 15.54 15.35 15.15C15.35 14.76 15.67 14.44 16.06 14.44ZM17.03 7.97L7.97 17.03C7.677 17.323 7.202 17.323 6.909 17.03C6.616 16.737 6.616 16.262 6.909 15.969L15.969 6.909C16.262 6.616 16.737 6.616 17.03 6.909C17.323 7.202 17.323 7.677 17.03 7.97Z"
      fill="#64748B"
    />
  </svg>
);
